import { Spin } from "antd";
import VerticalCenter from "../WrapCenter/VerticalCenter";

const MaskScreen = () => (
  <div
    style={{
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 4999,
      backgroundColor: "rgba(255, 255, 255, 0.45)",
      textAlign: "center",
    }}
  >
    <VerticalCenter>
      <Spin size="large" />
    </VerticalCenter>
  </div>
);

export default MaskScreen;
